import { type ReadonlySignal, signal } from "@preact/signals-core";
import type { LiveNote } from "../types/generated/live";

// What the Notas panel's island asks of the board it sits on. The board sets it once it is ready, for the master's own board only,
// and clears it when it goes; the panel never reaches into the board any other way.
export type NotesBridge = {
	// The scene's notes by id, in creation order.
	notes: ReadonlySignal<Record<string, LiveNote>>;
	selected: ReadonlySignal<string | null>;
	armed: ReadonlySignal<boolean>;
	// The marks are hidden on this device's board; the notes stay listed.
	hidden: ReadonlySignal<boolean>;
	toggleHidden: () => void;
	// Arms the tool, or puts it down when it is up.
	arm: () => void;
	// Selects a note and centres the map on it.
	select: (id: string) => void;
};

export const notesBridge = signal<NotesBridge | null>(null);
